import { useAdminUserStore } from '@/infrastructure/store/adminUserStore';

export const useAdminUsers = () => {
  const store = useAdminUserStore();
  return {
    users: store.users,
    userProfile: store.userProfile,
    isLoading: store.isLoading,
    error: store.error,
    fetchUsers: store.fetchUsers,
    fetchUserProfile: store.fetchUserProfile,
    changeUserRole: store.changeUserRole,
    deleteUser: store.deleteUser,
    clearUserProfile: store.clearUserProfile,
    clearError: store.clearError,
  };
};
